import { get } from "lodash";

const getFreezeExemptContractTypesSaving = state =>
  Boolean(get(state, "factoringClient.freezeExemptSaving", false));

export default getFreezeExemptContractTypesSaving;
